<div [class.isPrinting]="printService.isPrinting">
  <div class="job-posts placements agreements margin-top-service-30px">
    <div class="card skillassest-form">
      <!--<div class="card-header wh-header card-title-schedule-bb card-title-schedule-bl padding-l-8px  padding-bottom padding-top-5">
        Services Configuration
      </div>-->



  </div>
  <div class="card-body padding-top padding-left-0px padding-right-30px">
    <div class="row">
      <div class="col-md-2 padding-right-0px">
        <div class="position-fixed-cryo border-right2 padding-right-0px">
          <div class="card height-600px">

            <div class="card-header wh-header header3 padding-right-0px padding-bottom-0px bk-color-light">
              <div class="row margin-top10px margin-left-20px card-title-schedule-bb" *ngIf="SelectedTreatmentCycle">

                <label class="wh-header font-weight-normal card-title-schedule-bl2 border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px bk-color-light">
                  {{SelectedTreatmentCycle.OwnerName}}
                </label>
                <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
             ><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

              </div>



            </div>
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light">
              <div class="row margin-top-4px" *ngIf="SelectedTreatmentCycle">
                <div class="offset-md-2 col-md-3">
                  <img class="img-circle-50" [src]="SelectedTreatmentCycle.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
                </div>
              </div>

              <div class="row" *ngIf="SelectedTreatmentCycle">
                <div class=" col-md-11 text-align-center" >
                  <label class="font-size-13px margin-bottom-0px">{{SelectedTreatmentCycle.OwnerFormattedCode}}</label>
                </div>
              </div>

              <div class="row" *ngIf="SelectedTreatmentCycle">
                <div class="col-md-11 text-align-center">
                  <!--<label class="font-size-13px margin-bottom-0px">
                    {{SelectedTreatmentCycle.OwnerAgeYears}},{{SelectedTreatmentCycle.OwnerGender}}
                  </label>-->
                  <div [ngSwitch]="SelectedTreatmentCycle.OwnerGender">
                    <div *ngSwitchCase="'F'" class="font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px "> Female</label>-->
                      {{SelectedTreatmentCycle.OwnerAgeYears}},Female
                    </div>
                    <div *ngSwitchCase="'M'" class="font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px label-table-color"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>-->
                      {{SelectedTreatmentCycle.OwnerAgeYears}},Male
                    </div>


                    <div *ngSwitchCase="'O'" class="td-brorder-8px-blue font-size-12px">
                      <!--<label class="margin-left-3 margin-bottom-0px label-table-color margin-bottom-0px"> {{l.StartDate| date:'MMM-dd-yyyy'}}</label>-->
                      {{SelectedTreatmentCycle.OwnerAgeYears}},Other
                    </div>
                  </div>
                </div>
              </div>
              <div class="row border-bottom-light margin-right-0px margin-left-0px" *ngIf="SelectedTreatmentCycle" >
                <!--<div class="col-md-3">
            <label>Phone Number:</label>
          </div>-->
                <div class="col-md-11 text-align-center">
                  <label class="margin-bottom-0px font-size-13px">{{SelectedTreatmentCycle.OwnerTelephone2}}</label>
                </div>
              </div>
              <!--<div class="row border-bottom  rowfor margin-left-zero margin-right-0px nav-link-hand padding-all-5px" (click)="ShowPalnDetails(p)" *ngFor="let p of CurrentCounsellingPlanController">
          <div class="col-md-6">
            <div class="row height-20px margin-left-zero color-Assign" >

              <a class="nav-link-hand margin-left-5px font-size-16px">{{p.TreatmentPlan}}</a>
            </div>
            <div class="row">
              <label class="margin-left-20p font-size-11px margin-bottom-0px">{{p.StartDate| date:'dd-MMM-yyyy'}}</label>
            </div>

          </div>
          <div class="col-md-6">
            <i class="fa fa-check tick-mark-styles" *ngIf="p.PlanStatus=='Active'"></i>
          </div>

        </div>-->
              <div>

              </div>

            </div>

          </div>
        </div>
      </div>
     

        <div class="col-md-10  margin-top17px padding-right-0px padding-left-5px">
          <div class="row">
            <div class="col-md-12 padding-right-0px">
              <div class="card">
                <div class="card-header wh-header card-title-schedule-bl2 font-weight-normal padding-top-6px padding-bottom-6px padding-left-5px card-title-schedule-bb">
                  <div class="row nav-link-hand">
                    <div class="col-md-11 padding-left-0px">
                      <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                        Cryo Storage
                      </label>
                    </div>
                    <div class="col-md-1">
                      <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printcryo()">
                        <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="GradingModel=='Well Culture'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                Egg
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
          </div>-->
                        </div>


                      </div>

                      <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
              <div class="row">
                <div class="col-md-3">
                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                </div>
                <div class="col-md-3 text-align-right">
                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                </div>
              </div>

            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero">

                                        <thead class="">
                                          <tr>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Date</th>


                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Well#</th>

                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Morphology</th>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary padding-left-0px">Storage</th>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Details</th>
                                            <th class="padding-top-4px padding-bottom-4px padding-right-0px font-weight-normal background-primary padding-left-0px">Status</th>

                                          </tr>
                                        </thead>
                                        <tbody class="table-body">
                                          <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                          <!--</ng-container>-->
                                          <tr *ngFor="let l of EggList">

                                            <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>

                                            <td class="padding-right-0px padding-top-0px padding-bottom-0px">{{l.WellNo}}</td>

                                            <td class="padding-top-0px padding-bottom-0px">{{l.Morphology}}</td>

                                            <td class="padding-all-0px">

                                              <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                              required></CodeTypeValue>-->
                                              {{l.StorageUnitType}}
                                            </td>
                                            <td class="padding-top-0px padding-bottom-0px">
                                              <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                     id="l.StorageUnitDetails"
                                     [(ngModel)]="l.StorageUnitDetails"
                                     name="l.StorageUnitDetails" #Remarks="ngModel"
                                     maxlength="100">
                              <small class="form-text text-danger"
                                     *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                              {{l.StorageUnitDetails}}
                                            </td>
                                            <td class="padding-top-0px padding-bottom-0px  padding-left-0px">
                                              <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                </i>
                                              </a>
                                            </td>
                                            <!--<td class="padding-all-0px">
                              <button type="submit" (click)="onSubmit2(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l?.IsSelected"><i class="far fa-save"></i></button>


                            </td>-->



                                          </tr>
                                        </tbody>

                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion margin-bottom-20px" id="accordionExampleTwo" *ngIf="GradingModel=='Well Culture'">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Sperm
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 ">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                          </div>
                          <!--<div class="col-md-6">
            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
          </div>-->
                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExampleTwo">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="card margin-bottom-0px">
                            <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
              <div class="row">
                <div class="col-md-3">
                  <label class="font-weight-normal font-size-14">Add/Edit</label>
                </div>
                <div class="col-md-3 text-align-right">
                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                  <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                </div>
              </div>

            </div>-->
                            <div class="card-body padding-top-0px padding-bottom-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <thead class="">
                                      <tr>
                                        <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">Date</th>
                                        <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">
                                          Storage Type
                                        </th>
                                        <!--<th class="text-align-center">Day</th>-->
                                        <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">
                                          Volume
                                        </th>


                                        <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px">
                                          Storage Unit Details
                                        </th>












                                      </tr>
                                    </thead>
                                    <tbody class="table-body">
                                      <tr *ngFor="let l of CurrentIvfSpermStoreByCodeController">
                                        <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>
                                        <td class="padding-top-0px padding-bottom-0px">
                                          {{l.StorageUnitType}}
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px">
                                          {{l.Volume}}{{l.VolumeUnits}}
                                        </td>
                                        <td class="padding-top-0px padding-bottom-0px">{{l.StorageUnitDetails}}</td>
                                      </tr>

                                    </tbody>

                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion" id="accordionExample2" *ngIf="GradingModel=='Well Culture'">

                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Embryo
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>

                          </div>
                          <!--<div class="col-md-6">
            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
          </div>-->
                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                        <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                          <div class="card margin-bottom-0px margin-top-10">

                            <div class="card-body padding-top-0px padding-bottom-0px  padding-right-0px">

                              <div class="row">
                                <div class="col-md-12 ">
                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero">

                                        <thead class="">
                                          <tr>

                                            <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px ">Date</th>

                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Well#</th>

                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Grade</th>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary padding-left-0px">Storage</th>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Details</th>
                                            <th class="padding-top-4px padding-bottom-4px padding-right-0px font-weight-normal background-primary">Status</th>

                                          </tr>
                                        </thead>
                                        <tbody class="table-body">
                                          <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                          <!--</ng-container>-->
                                          <tr *ngFor="let l of EmbryoList">

                                            <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>

                                            <td class="padding-top-0px padding-bottom-0px">{{l.WellNo}}</td>

                                            <td class="padding-top-0px padding-bottom-0px">{{l.Grade}}</td>

                                            <td class="padding-all-0px">
                                              <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                              required></CodeTypeValue>-->
                                              {{l.StorageUnitType}}
                                            </td>
                                            <td class="padding-top-0px padding-bottom-0px">
                                              <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                     id="l.StorageUnitDetails"
                                     [(ngModel)]="l.StorageUnitDetails"
                                     name="l.StorageUnitDetails" #Remarks="ngModel"
                                     maxlength="100">
                              <small class="form-text text-danger"
                                     *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                              {{l.StorageUnitDetails}}
                                            </td>
                                            <td class="padding-top-0px padding-bottom-0px">
                                              <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                </i>
                                              </a>
                                            </td>




                                          </tr>
                                        </tbody>

                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

          <div class="card margin-bottom-0px background-lightpink">

            <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
              <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero">

                    <thead class="">
                      <tr>
                        <th class=" td-width-107px">Ov.Position</th>
                        <th class="padding-left-5px width-70px">Count</th>
                        <th class="padding-left-5px width-70px">Size</th>
                        <th>Comments</th>

                      </tr>
                    </thead>
                    <tbody class="table-body">

                      <tr>

                        <td>
                          <CodeTypeValue CodeType="OVPS"
                                         id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                          </CodeTypeValue>
                        </td>

                        <td class="td-padding ">

                          <input type="number" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                        </td>
                        <td class="td-padding ">
                          <input type="text" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                        </td>

                        <td class="td-padding ">
                          <input type="text" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                        </td>



                      </tr>

                    </tbody>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>-->
                      </div>
                    </div>


                  </div>
                  <div class="accordion" id="accordionExample2" *ngIf="GradingModel=='Droplet Culture'">

                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                Embryo
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>

                          </div>
                          <!--<div class="col-md-6">
            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
          </div>-->
                        </div>


                      </div>

                      <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                        <div class="card-body padding-top-0px padding-bottom-0px margin-left-0px padding-left-0px padding-right-0px">

                          <div class="card margin-bottom-0px margin-top-10">

                            <div class="card-body padding-top-0px padding-bottom-0px  padding-right-0px">

                              <div class="row">
                                <div class="col-md-12 ">
                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero">

                                        <thead class="">
                                          <tr>

                                            <th class="font-weight-normal td-padding-tb background-primary padding-top-4px padding-bottom-4px ">Date</th>

                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Well#</th>

                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Grade</th>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary padding-left-0px">Storage</th>
                                            <th class="padding-top-4px padding-bottom-4px font-weight-normal background-primary">Details</th>
                                            <th class="padding-top-4px padding-bottom-4px padding-right-0px font-weight-normal background-primary">Status</th>

                                          </tr>
                                        </thead>
                                        <tbody class="table-body">
                                          <!--<ng-container *ngFor="let l of CurrentSingleWellInseminationByCycleController;let i = index">-->
                                          <!--</ng-container>-->
                                          <tr *ngFor="let l of EmbryoList">

                                            <td>{{l.LastUpdateDate| date:'MMM-dd-yyyy'}}</td>

                                            <td class="padding-top-0px padding-bottom-0px">{{l.WellNo}}</td>

                                            <td class="padding-top-0px padding-bottom-0px">{{l.Grade}}</td>

                                            <td class="padding-all-0px">
                                              <!--<CodeTypeValue CodeType="OST" [(ngModel)]="l.StorageUnitType" SelectedValue="l.StorageUnitType"
                              required></CodeTypeValue>-->
                                              {{l.StorageUnitType}}
                                            </td>
                                            <td class="padding-top-0px padding-bottom-0px">
                                              <!--<input type="text" class="form-control" min="1" max="10" placeholder="Details"
                                     id="l.StorageUnitDetails"
                                     [(ngModel)]="l.StorageUnitDetails"
                                     name="l.StorageUnitDetails" #Remarks="ngModel"
                                     maxlength="100">
                              <small class="form-text text-danger"
                                     *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                              <small class="form-text text-danger"
                                     *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>-->
                                              {{l.StorageUnitDetails}}
                                            </td>
                                            <td class="padding-top-0px padding-bottom-0px">
                                              <a class="color-datacolor font-weight-normal text-decoration font-size-14">
                                                <i class="fas fa-circle color-Assign nav-link-hand  ">
                                                </i>
                                              </a>
                                            </td>




                                          </tr>
                                        </tbody>

                                      </table>

                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <!--<div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

          <div class="card margin-bottom-0px background-lightpink">

            <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
              <div class="table-component margin-bottom-0px padding-all-3px" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                <div class="table-responsive">


                  <table class="table table-striped margin-left-zero">

                    <thead class="">
                      <tr>
                        <th class=" td-width-107px">Ov.Position</th>
                        <th class="padding-left-5px width-70px">Count</th>
                        <th class="padding-left-5px width-70px">Size</th>
                        <th>Comments</th>

                      </tr>
                    </thead>
                    <tbody class="table-body">

                      <tr>

                        <td>
                          <CodeTypeValue CodeType="OVPS"
                                         id="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos"
                                         [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" SelectedValue=""
                                         name="CurrentSaveFollicularScanOvaryDetailRequest.OvarPos" required>

                          </CodeTypeValue>
                        </td>

                        <td class="td-padding ">

                          <input type="number" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Count"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.Count" #Count="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!Count.valid && (Count.dirty || Count.touched) && Count.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Count.valid && Count.errors.pattern)">(special characters are not allowed)</small>

                        </td>
                        <td class="td-padding ">
                          <input type="text" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Size"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.Size" #Size="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!Size.valid && (Size.dirty || Size.touched) && Size.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Size.valid && Size.errors.pattern)">(special characters are not allowed)</small>
                        </td>

                        <td class="td-padding ">
                          <input type="text" class="form-control"
                                 min="1" max="10" id="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                 [(ngModel)]="CurrentSaveFollicularScanOvaryDetailRequest.Remarks"
                                 name="CurrentSaveFollicularScanOvaryDetailRequest.Remarks" #Remarks="ngModel"
                                 maxlength="100">
                          <small class="form-text text-danger"
                                 *ngIf="(!Remarks.valid && (Remarks.dirty || Remarks.touched) && Remarks.errors.required )">(Field cannot be left blank)</small>
                          <small class="form-text text-danger"
                                 *ngIf="(!Remarks.valid && Remarks.errors.pattern)">(special characters are not allowed)</small>
                        </td>



                      </tr>

                    </tbody>

                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>-->
                      </div>
                    </div>


                  </div>
                </div>
           </div>
         </div>
       </div>
         
         

         


       


      </div>

     
    </div>
  </div>

</div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
